import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { CerAppRouteService } from 'src/cer-app/cer-app-route/cer-app-route.service';

@Component({
  selector: 'scheduler-status',
  template: '<iframe [src]="urlJobScheduler" frameborder="0" width="100%" height="100%"></iframe>',
  styles: [':host { height: 100%; width: 100%; }']
})
export class CerAppSchedulerStatusComponent implements OnInit {

  private urlJobSchedulerLoaded: string = '/status/jobs-dashboard';
  public urlJobScheduler: SafeResourceUrl;

  constructor(
    private routeService: CerAppRouteService,
    private domSanitizer: DomSanitizer, 
    ) {
      this.urlJobScheduler = this.domSanitizer.bypassSecurityTrustResourceUrl(this.urlJobSchedulerLoaded);
  }

  ngOnInit(): void {
    this.routeService.setIsLoading(false); 
  }
}
